/**
 * Trace / span / event id helpers.
 *
 * We generate our own W3C-compatible trace ids (16 hex bytes) and span ids
 * (8 hex bytes) so logs and traces share consistent correlation ids even when
 * no third-party SDK is loaded.
 */

/** Random 128-bit hex string (32 chars), lowercase — W3C trace id. */
export function newTraceId(): string {
  return randomHex(16);
}

/** Random 64-bit hex string (16 chars), lowercase — W3C span id. */
export function newSpanId(): string {
  return randomHex(8);
}

/** UUID v4 for event ids. */
export function newEventId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return randomHex(16) + randomHex(16);
}

function randomHex(bytes: number): string {
  const buf = new Uint8Array(bytes);
  if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
    crypto.getRandomValues(buf);
  } else {
    for (let i = 0; i < bytes; i += 1) buf[i] = Math.floor(Math.random() * 256);
  }
  return Array.from(buf, (b) => b.toString(16).padStart(2, "0")).join("");
}
